<template>
    <div class="wrap-input"
        :class="[{'input-error': isSubmitted && isShowError && !errorInfo.isValid}, {'input-no-lbl': isHideLabel},customClass]">
        <div class="input-wrapper">
            <input type="text"
                   class="input-field"
                   ref="input-field"
                   name="input-text"
                   :id="id"
                   :maxlength="maxLength"
                   :readonly="readOnly"
                   :autocomplete="'text-input'"
                   v-model="content"
                   @blur="onBlur($event)"
                   @focus="onFocus($event)"
                   @input="onChange()" />
            <div class="input-lbl" 
                v-if="label && !isHideLabel">
                {{label}}
            </div>
            <div :class="[isHideLabel ? 'input-placeholder-no-lbl':'input-placeholder']"
                v-if="placeholder && !content" @click="focusInput()">
                {{placeholder}}
            </div>
            <div v-if="content && iconClear" class="icon-clear" @click="clearText()">
                <img src="@/assets/icon/newversion/ic-clear.svg" alt="">
            </div>
        </div>
        <div class="input-error-txt"
             v-if="isShowError"
             v-show="isSubmitted && !errorInfo.isValid">{{errorInfo.msg}}</div>
    </div>
</template>
<script>
import Vue from 'vue';
import Util from '@/helper/Utility.js';
/**
 * Property
 * @property {string} addClass (optional) Add css class
 * @property {boolean} blockAutoComplete (optional) Block borwser auto complete field.
 * @property {object} errorInfo (optional) Validate result. example : { isValid: true, msg: '',}
 * @property {string} inputId (required) Field id for emit.
 * @property {object} inputLbl (required) Text for component.
 * @property {number} inputMinLength (optional) Minimum length.
 * @property {number} inputMaxLength (optional) Maximum Length.
 * @property {boolean} isShowError (optional) Show/Hide Error label.
 * @property {boolean} isSubmitted (required) Show/Hide Error after save.
 * @property {boolean} isTextOnly (optional) Only text.
 * Event
 * @event onChange Filter and validate.
 * Method
 * @method validateInput Validate text.
 */
export default {
    name: 'TextInput',
    props: {
        //v-model
        value: String,
        //props
        addClass: String,
        blockAutoComplete: Boolean,
        errorInfo: Object,
        inputId: String,
        inputLbl: Object,
        inputMinLength: Number,
        inputMaxLength: Number,
        isHideLabel: Boolean,
        isShowError: Boolean,
        isSubmitted: Boolean,
        isTextOnly: Boolean,
        busText: Object,
        iconClear: Boolean,
    },
    data: function () {
        return {
            id: '',
            label: '',
            placeholder: '',
            content: this.value,
            minLength: 0,
            maxLength: 0,
            readOnly: true,
            customClass: '',
        };
    },
    watch: {
        value: function (newVal) {
            this.content = newVal;
            this.onChange();
        }
    },
    mounted: function () {
        this.id = this.inputId;
        this.label = this.inputLbl.name || '';
        this.placeholder = this.inputLbl.placeholder || '';
        this.minLength = this.inputMinLength || null;
        this.maxLength = this.inputMaxLength || null;
        this.customClass = this.addClass || '';
        this.validateInput();

        this.readOnly = this.blockAutoComplete;
        setTimeout(() => {
            this.readOnly = this.blockAutoComplete || false;
        }, 500);
    },
    methods: {
        onBlur: function () {
            if (this.busText)
                this.busText.$emit('onBlur', {});
            if (this.content == '') {
                this.placeholder = this.inputLbl.placeholder;
            }
        },
        onFocus: function() {
            if (this.busText)
                this.busText.$emit('onFocus', {});
                this.placeholder = '';
        },
        focusInput: function () {
            this.$refs['input-field'].focus();
        },
        validateInput: function () {
            if(!this.inputLbl) return;
            //Set default.
            this.errorInfo.isValid = true;
            this.errorInfo.msg = '';
            //Required
            if(this.inputLbl.required
                && !this.content) {

                this.errorInfo.isValid = false;
                this.errorInfo.msg = this.inputLbl.required;
                return;
            }
            //Too short
            if(this.inputLbl.too_short && this.minLength
                && (this.content.length < this.minLength)) {

                this.errorInfo.isValid = false;
                this.errorInfo.msg = Util.stringFormat(this.inputLbl.too_short, this.minLength);
                return;
            }
            //InValid format
            if(this.inputLbl.invalid) {
                this.errorInfo.isValid = false;
                this.errorInfo.msg = this.inputLbl.invalid;
                return;
            }
        },
        onChange: function () {
            var result = this.content;
            //Remove restrict character.
            result = result.replace(Vue.RegExp.emoji, '');

            if(this.isTextOnly) {
                result = result.replace(Vue.RegExp.number, '');
                result = result.replace(Vue.RegExp.symbol, '');
            }

            this.content = result;
            this.validateInput();
            this.$emit('input', result);
        },
        clearText: function () {
            this.content = '';
            this.validateInput();
            this.$emit('input', '');
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/Input/Text.scss";
.wrap-input {
    @extend %input-base;
}
</style>
